import { COOKIES as SHARED_COOKIES } from '@avanta/shared/constants/storage';

export const STORAGE_PREFIX = import.meta.env.VITE_STORAGE_PREFIX || 'avanta-patient-';

export const COOKIES = {
  ...SHARED_COOKIES,
  DAILY_TRACKING_CLOSED: 'daily_tracking_closed',
};

export const SESSION_STORAGE = {
  CHECKOUT_APPOINTMENT_DATA: 'checkout_appointment_data',
  CHAT_STATUS_BANNER_CLOSED: 'chat_status_banner_closed',
};
